function trim(value) {
  if (value && typeof value === 'string') return value.trim();
  return '';
}

export { trim };
export default trim;
